import router from '@/router';
import { LOGIN_TOKEN_KEY, LOGIN_USER_INFO } from '@/utils/constants';

export const handleLoginFailure = () => {
    console.log('401 处理');
	localStorage.removeItem(LOGIN_TOKEN_KEY);
	localStorage.removeItem(LOGIN_USER_INFO);
    router.push('/home');
}
export function dateFormatL(fmt, date) {
	if (date == null || date == '' || date == undefined)
		return '';
		
	try {
		//解决ios手机时间格式化NAN问题
		if (typeof(date) == "string" && date.indexOf('-') != -1) {
			date = date.replace(/-/g, '/');
		}
		date = new Date(date);
	} catch (e) {
		date = date;
	}
	let ret
	const opt = {
		'Y+': date.getFullYear().toString(), // 年
		'm+': (date.getMonth() + 1).toString(), // 月
		'd+': date.getDate().toString(), // 日
		'H+': date.getHours().toString(), // 时
		'M+': date.getMinutes().toString(), // 分
		'S+': date.getSeconds().toString(), // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	}
	for (let k in opt) {
		ret = new RegExp('(' + k + ')').exec(fmt)
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
		}
	}
	return fmt
}
/**
 * 
 * @param {*} fileUrl 文件在线地址
 * @param {*} fileName 文件名
 * @returns Promise
 */
export function previewFile(fileUrl, fileName, onlyDeleteFile) {
	let tempPdfPath = wx.env.USER_DATA_PATH + "/";
	let fm = uni.getFileSystemManager();
	let cancel = false;

	let downFunc = (resolve) => {
		uni.downloadFile({
			filePath: tempPdfPath + fileName,
			url: fileUrl,
			success: function (res) {
				const filePath = res.filePath; // 临时文件路径
				!cancel && uni.openDocument({
					filePath: filePath,
					showMenu: false,
					success: function () {
						uni.hideLoading();
					},
					fail: function (err) {
						console.log("打开文件失败", err);
						uni.hideLoading();
						uni.showToast({
							title: err.errMsg,
							icon: "none",
							duration: 3000,
						});
					},
				});
				resolve(filePath);
			},
			fail: function (err) {
				console.log("下载文件失败", err);
				uni.hideLoading();
				uni.showToast({
					title: err.errMsg,
					icon: "none",
					duration: 3000,
				});
			},
		});
  	};

	let p = new Promise((resolve, reject) => {
		!onlyDeleteFile && uni.showLoading({
      		title: "文件加载中",
      		mask: true,
    	});
		fm.readdir({
			dirPath: tempPdfPath,
			success: function (res) {
				console.log("获取文件列表", res);
				let fileList = res.files.filter(d => d.indexOf('.pdf') >= 0);
				if (fileList.length) {
					Promise.all(
            			fileList.map((d) => deleteFilePromise(`${tempPdfPath}${d}`))
					).then(resList => {
						!cancel && !onlyDeleteFile && downFunc(resolve);
					}).catch(err => {
						reject(err);
					});
				} else {
					!cancel && !onlyDeleteFile && downFunc(resolve);
				}
			},
			fail: function (err) {
				console.log('获取文件列表失败', err);
			}
		});
	});
	let abort = (text) => {
		console.error(text);
    	cancel = true;
  	};
	return [p, abort];
}
export function deleteFile(filePath) {
	let fm = uni.getFileSystemManager();
	fm.access({
		path: filePath,
		success: function (res) {
			console.log("文件存在", res, filePath);
			fm.unlink({
				filePath: filePath,
				success: function (res) {
					console.log("删除成功", res);
				},
				fail: function (err) {
					console.log("删除文件失败", err);
				},
			});
		},
		fail: function (err) {
			console.log('判断文件存在失败', err);
		},
	});
}

export function getFileSize(kb) {
	if (kb >= 1024) {
		return `${(kb / 1024).toFixed(2)} MB`;
	}
	return `${kb.toFixed(2)} KB`;
}
export function preDownloadFile({fileUrl, fileName, progress, success}) {
  	let tempPdfPath = wx.env.USER_DATA_PATH + "/";
	let fm = uni.getFileSystemManager();

	let taskFunc = () => {
		let task = uni.downloadFile({
			filePath: tempPdfPath + fileName,
			url: fileUrl,
			success: function (res) {
				const filePath = res.filePath; // 临时文件路径
				success(filePath);
			},
			fail: function (err) {
				console.log("下载文件失败", err);
				uni.hideLoading();
				uni.showToast({
					title: err.errMsg,
					icon: "none",
					duration: 3000,
				});
			},
		});
		task.onProgressUpdate((result) => {
			progress(result);
		});
	};

  	fm.readdir({
    	dirPath: tempPdfPath,
    	success: function (res) {
      		console.log("获取文件列表", res);
      		let fileList = res.files.filter((d) => d.indexOf(".pdf") >= 0);
      		if (fileList.length) {
        		Promise.all(
          			fileList.map((d) => deleteFilePromise(`${tempPdfPath}${d}`))
        		)
          		.then((resList) => {
            		taskFunc();
          		})
          		.catch((err) => {});
			} else {
				taskFunc();					
			}
    	},
    	fail: function (err) {
      		console.log("获取文件列表失败", err);
    	},
  	});
}

export function transformColor(color, opacity) {
	let r = parseInt(color.slice(1, 3), 16);
	let g = parseInt(color.slice(3, 5), 16);
	let b = parseInt(color.slice(5, 7), 16);
	return `rgba(${r},${g},${b},${opacity})`;
}
